<div class="entry-card">
  <div class="entry-card__body">
    <div class="entry-card__head">
      <span class="entry-card__badge">{{ number }}</span>
      <span class="entry-card__name">{{ title }}</span>
      <span class="entry-card__actions">
        <button class="entry-card__action entry-card__action--edit">Edit</button>
        <button class="entry-card__action entry-card__action--remove" (click)="removePressed.emit()">Remove</button>
      </span>
    </div>

    <div class="entry-card__row entry-card__row--items">
      <span class="entry-card__label">Items</span>
      <span class="entry-card__items">
        @for (chip of chips; track $index) {
          <s-polaris-product-thumbnail
            [image]="chip.thumbnail"
            [quantity]="chip.quantity"
            [size]="44"></s-polaris-product-thumbnail>
        }
      </span>
    </div>

    @for (row of rows; track row.label) {
      <div class="entry-card__row">
        <span class="entry-card__label">{{ row.label }}</span>
        <span class="entry-card__value">{{ row.value }}</span>
      </div>
    }
  </div>
</div>
